import ReactCodeInput from 'react-code-input';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import Paragraph from '../Paragraph/Paragraph';
import { uFlexColumn } from '../../assets/styles/utility';
import { mediaBelow, pxToRem } from '../../assets/styles/helper';
import themeColors from '../../assets/styles/themeColors';

export const CodeFieldContainer = styled.div`
  ${uFlexColumn};
  width: 100%;

  .react-code-input {
    display: grid !important;
    width: 100% !important;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: ${pxToRem(8)};

    > input {
      width: 100% !important;
      height: 49px !important;
      border: 1px solid ${themeColors.colorBorderPrimary} !important;
      border-radius: 4px !important;
      text-align: center !important;
      padding: 0 !important;
      box-shadow: none !important;
      color: ${themeColors.colorTextPrimary} !important;
      outline: none !important;
      margin: 0 !important;
      -moz-appearance: ${({ mozillaStyle }) => mozillaStyle || ''};

      &:disabled {
        background-color: ${themeColors.colorTextGrey} !important;
        border-color: ${themeColors.colorBorderPrimary} !important;
      }

      &:focus {
        border-color: ${themeColors.colorPrimary} !important;
      }
    }
  }

  ${({ hasError }) =>
    hasError &&
    `.react-code-input {
      > input {
        border-color: ${themeColors.colorErrorMessage} !important;
      }
    }
  `};

  ${({ fixedSize }) =>
    fixedSize &&
    `
    .react-code-input {
      grid-template-columns: repeat(4, 49px);
      grid-gap: ${pxToRem(24)};
      width: auto !important;

      > input {
        height: 49px !important;
      }
    }
  `};
}

  ${mediaBelow(400)} {
    .react-code-input {
      grid-gap: ${pxToRem(12)};
    }
  }

  ${mediaBelow(480)} {
    .react-code-input {
      grid-template-columns: repeat(4, 49px);
      grid-template-rows: repeat(2, 49px);
    }
  }
`;

const CodeField = ({
  numFields,
  onCodeChange,
  errors,
  fixedSize,
  fieldName,
  mozillaStyle,
  ...props
}) => (
  <>
    <CodeFieldContainer
      hasError={!isEmpty(errors)}
      fixedSize={fixedSize}
      mozillaStyle={mozillaStyle}
      {...props}
    >
      <ReactCodeInput
        fields={numFields}
        type="number"
        onChange={onCodeChange}
        {...props}
      />
      {errors[fieldName] && (
        <Paragraph variant="small" mt={8} color={themeColors.colorErrorMessage}>
          {errors[fieldName]?.message}
        </Paragraph>
      )}
    </CodeFieldContainer>
  </>
);

CodeField.propTypes = {
  numFields: PropTypes.number,
  onCodeChange: PropTypes.func,
  errors: PropTypes.shape({}),
  fieldName: PropTypes.string,
  fixedSize: PropTypes.bool,
  mozillaStyle: PropTypes.string,
};

export default CodeField;
